import React from "react";
import ComplianceReportDetail from "components/newDesign/compliance/ComplianceReportDetail";

const ComplianceReportDetailPage = () => {
  return <ComplianceReportDetail />;
};

export default ComplianceReportDetailPage;
